
// src/redux/actions/authActions.js
import axios from "axios";
// // Assuming the API URL is set in your .env file
const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const login = (email, password) => async (dispatch) => {
  try {
    const response =  await axios.post(`${BASE_URL}/v1/api/loginAdmin`, {
              email,
              password,
            });

    if (response.data.meta.status) {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: "LOGIN_FAIL" });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: "LOGIN_FAIL" });
    throw error;
  }
};





// Logout action - clears the user session and token
export const logout = () => async (dispatch) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      await axios.post(`${BASE_URL}/v1/api/logoutadmin`, null, {
        headers: {
          authorization: `${token}`,
        },
      });

      // Clear the token from Redux store and localStorage
      localStorage.removeItem('token');
      dispatch({ type: "LOGOUT" });
    }
  } catch (error) {
    console.error('Logout error:', error);
    dispatch({ type: "LOGOUT" }); // Even if the API fails, we log out the user locally
  }
};